/**
 * COSI API
 * COSI Platform REST APIs
 *
 * The version of the OpenAPI document: v0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Request
 */
export interface FinalizeSignatureRequest {
  /**
   * Certificate
   */
  certificate?: string;
  certificateChain?: Array<string>;
  signatureAlgorithm?: FinalizeSignatureRequest.SignatureAlgorithmEnum;
  signatureValue?: string;
  signingDate?: Date;
}
export namespace FinalizeSignatureRequest {
  export type SignatureAlgorithmEnum = 'RSA_RAW' | 'RSA_SHA1' | 'RSA_SHA224' | 'RSA_SHA256' | 'RSA_SHA384' | 'RSA_SHA512' | 'RSA_SHA3_224' | 'RSA_SHA3_256' | 'RSA_SHA3_384' | 'RSA_SHA3_512' | 'RSA_SSA_PSS_RAW_MGF1' | 'RSA_SSA_PSS_SHA1_MGF1' | 'RSA_SSA_PSS_SHA224_MGF1' | 'RSA_SSA_PSS_SHA256_MGF1' | 'RSA_SSA_PSS_SHA384_MGF1' | 'RSA_SSA_PSS_SHA512_MGF1' | 'RSA_SSA_PSS_SHA3_224_MGF1' | 'RSA_SSA_PSS_SHA3_256_MGF1' | 'RSA_SSA_PSS_SHA3_384_MGF1' | 'RSA_SSA_PSS_SHA3_512_MGF1' | 'RSA_RIPEMD160' | 'RSA_MD2' | 'RSA_MD5' | 'ECDSA_RAW' | 'ECDSA_SHA1' | 'ECDSA_SHA224' | 'ECDSA_SHA256' | 'ECDSA_SHA384' | 'ECDSA_SHA512' | 'ECDSA_SHA3_224' | 'ECDSA_SHA3_256' | 'ECDSA_SHA3_384' | 'ECDSA_SHA3_512' | 'ECDSA_RIPEMD160' | 'PLAIN_ECDSA_SHA1' | 'PLAIN_ECDSA_SHA224' | 'PLAIN_ECDSA_SHA256' | 'PLAIN_ECDSA_SHA384' | 'PLAIN_ECDSA_SHA512' | 'PLAIN_ECDSA_SHA3_224' | 'PLAIN_ECDSA_SHA3_256' | 'PLAIN_ECDSA_SHA3_384' | 'PLAIN_ECDSA_SHA3_512' | 'PLAIN_ECDSA_RIPEMD160' | 'DSA_RAW' | 'DSA_SHA1' | 'DSA_SHA224' | 'DSA_SHA256' | 'DSA_SHA384' | 'DSA_SHA512' | 'DSA_SHA3_224' | 'DSA_SHA3_256' | 'DSA_SHA3_384' | 'DSA_SHA3_512' | 'HMAC_SHA1' | 'HMAC_SHA224' | 'HMAC_SHA256' | 'HMAC_SHA384' | 'HMAC_SHA512' | 'HMAC_SHA3_224' | 'HMAC_SHA3_256' | 'HMAC_SHA3_384' | 'HMAC_SHA3_512' | 'HMAC_RIPEMD160' | 'ED25519' | 'ED448';
  export const SignatureAlgorithmEnum = {
    RSA_RAW: 'RSA_RAW' as SignatureAlgorithmEnum,
    RSA_SHA1: 'RSA_SHA1' as SignatureAlgorithmEnum,
    RSA_SHA224: 'RSA_SHA224' as SignatureAlgorithmEnum,
    RSA_SHA256: 'RSA_SHA256' as SignatureAlgorithmEnum,
    RSA_SHA384: 'RSA_SHA384' as SignatureAlgorithmEnum,
    RSA_SHA512: 'RSA_SHA512' as SignatureAlgorithmEnum,
    RSA_SHA3_224: 'RSA_SHA3_224' as SignatureAlgorithmEnum,
    RSA_SHA3_256: 'RSA_SHA3_256' as SignatureAlgorithmEnum,
    RSA_SHA3_384: 'RSA_SHA3_384' as SignatureAlgorithmEnum,
    RSA_SHA3_512: 'RSA_SHA3_512' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_RAW_MGF1: 'RSA_SSA_PSS_RAW_MGF1' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_SHA1_MGF1: 'RSA_SSA_PSS_SHA1_MGF1' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_SHA224_MGF1: 'RSA_SSA_PSS_SHA224_MGF1' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_SHA256_MGF1: 'RSA_SSA_PSS_SHA256_MGF1' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_SHA384_MGF1: 'RSA_SSA_PSS_SHA384_MGF1' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_SHA512_MGF1: 'RSA_SSA_PSS_SHA512_MGF1' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_SHA3_224_MGF1: 'RSA_SSA_PSS_SHA3_224_MGF1' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_SHA3_256_MGF1: 'RSA_SSA_PSS_SHA3_256_MGF1' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_SHA3_384_MGF1: 'RSA_SSA_PSS_SHA3_384_MGF1' as SignatureAlgorithmEnum,
    RSA_SSA_PSS_SHA3_512_MGF1: 'RSA_SSA_PSS_SHA3_512_MGF1' as SignatureAlgorithmEnum,
    RSA_RIPEMD160: 'RSA_RIPEMD160' as SignatureAlgorithmEnum,
    RSA_MD2: 'RSA_MD2' as SignatureAlgorithmEnum,
    RSA_MD5: 'RSA_MD5' as SignatureAlgorithmEnum,
    ECDSA_RAW: 'ECDSA_RAW' as SignatureAlgorithmEnum,
    ECDSA_SHA1: 'ECDSA_SHA1' as SignatureAlgorithmEnum,
    ECDSA_SHA224: 'ECDSA_SHA224' as SignatureAlgorithmEnum,
    ECDSA_SHA256: 'ECDSA_SHA256' as SignatureAlgorithmEnum,
    ECDSA_SHA384: 'ECDSA_SHA384' as SignatureAlgorithmEnum,
    ECDSA_SHA512: 'ECDSA_SHA512' as SignatureAlgorithmEnum,
    ECDSA_SHA3_224: 'ECDSA_SHA3_224' as SignatureAlgorithmEnum,
    ECDSA_SHA3_256: 'ECDSA_SHA3_256' as SignatureAlgorithmEnum,
    ECDSA_SHA3_384: 'ECDSA_SHA3_384' as SignatureAlgorithmEnum,
    ECDSA_SHA3_512: 'ECDSA_SHA3_512' as SignatureAlgorithmEnum,
    ECDSA_RIPEMD160: 'ECDSA_RIPEMD160' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_SHA1: 'PLAIN_ECDSA_SHA1' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_SHA224: 'PLAIN_ECDSA_SHA224' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_SHA256: 'PLAIN_ECDSA_SHA256' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_SHA384: 'PLAIN_ECDSA_SHA384' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_SHA512: 'PLAIN_ECDSA_SHA512' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_SHA3_224: 'PLAIN_ECDSA_SHA3_224' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_SHA3_256: 'PLAIN_ECDSA_SHA3_256' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_SHA3_384: 'PLAIN_ECDSA_SHA3_384' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_SHA3_512: 'PLAIN_ECDSA_SHA3_512' as SignatureAlgorithmEnum,
    PLAIN_ECDSA_RIPEMD160: 'PLAIN_ECDSA_RIPEMD160' as SignatureAlgorithmEnum,
    DSA_RAW: 'DSA_RAW' as SignatureAlgorithmEnum,
    DSA_SHA1: 'DSA_SHA1' as SignatureAlgorithmEnum,
    DSA_SHA224: 'DSA_SHA224' as SignatureAlgorithmEnum,
    DSA_SHA256: 'DSA_SHA256' as SignatureAlgorithmEnum,
    DSA_SHA384: 'DSA_SHA384' as SignatureAlgorithmEnum,
    DSA_SHA512: 'DSA_SHA512' as SignatureAlgorithmEnum,
    DSA_SHA3_224: 'DSA_SHA3_224' as SignatureAlgorithmEnum,
    DSA_SHA3_256: 'DSA_SHA3_256' as SignatureAlgorithmEnum,
    DSA_SHA3_384: 'DSA_SHA3_384' as SignatureAlgorithmEnum,
    DSA_SHA3_512: 'DSA_SHA3_512' as SignatureAlgorithmEnum,
    HMAC_SHA1: 'HMAC_SHA1' as SignatureAlgorithmEnum,
    HMAC_SHA224: 'HMAC_SHA224' as SignatureAlgorithmEnum,
    HMAC_SHA256: 'HMAC_SHA256' as SignatureAlgorithmEnum,
    HMAC_SHA384: 'HMAC_SHA384' as SignatureAlgorithmEnum,
    HMAC_SHA512: 'HMAC_SHA512' as SignatureAlgorithmEnum,
    HMAC_SHA3_224: 'HMAC_SHA3_224' as SignatureAlgorithmEnum,
    HMAC_SHA3_256: 'HMAC_SHA3_256' as SignatureAlgorithmEnum,
    HMAC_SHA3_384: 'HMAC_SHA3_384' as SignatureAlgorithmEnum,
    HMAC_SHA3_512: 'HMAC_SHA3_512' as SignatureAlgorithmEnum,
    HMAC_RIPEMD160: 'HMAC_RIPEMD160' as SignatureAlgorithmEnum,
    ED25519: 'ED25519' as SignatureAlgorithmEnum,
    ED448: 'ED448' as SignatureAlgorithmEnum
  };
}


